import { InmarBlindReturnStatus } from "@redotech/redo-return-core-common/integrations/returns/inmar/inmar-blind-return";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum UpdateInmarBlindReturnStatusErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT FOUND",
  RETURN_NOT_FOUND = "RETURN NOT FOUND",
}

export const updateInmarBlindReturnStatus = {
  name: "updateInmarBlindReturnStatus" as const,
  input: z.object({
    id: zExt.objectId(),
    status: createEnum(Object.values(InmarBlindReturnStatus)),
    connectedReturnId: z.string().optional(),
  }),

  output: z.object({ success: z.boolean() }),
};
